import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BigHeader, MediumHeader } from '@narvar/nth-header';
import Divider from '@narvar/nth-divider';
import { FAQ_LAYOUTS } from '../../constants/defaultSettings';
import NarvarFooter from '../NarvarFooter';

export const mapStateToProps = ({
  page: { productType } = {},
  language,
  returnsSettings: { [productType]: { faq: retailerFaqLayouts = {} } = {} } = {},
}) => ({
  language,
  retailerFaqLayouts,
});

const FaqPage = ({ feature, language, retailerFaqLayouts }) => {
  const layout = retailerFaqLayouts[feature] || FAQ_LAYOUTS[feature];

  return (
    <div
      className={`faq-container-${feature}`}
      style={{ maxWidth: '630px', margin: '0 auto', padding: '0 1rem' }}
    >
      <BigHeader s={{ margin: '4.5rem 0' }}>{language[layout.title]}</BigHeader>
      {layout.sections.map(({ title, description }, index) => (
        <div>
          <MediumHeader
            s={{ margin: '0.5rem 0' }}
            dangerouslySetInnerHTML={{ __html: language[title] }}
          />
          <p
            style={{ margin: '0.5rem 0' }}
            dangerouslySetInnerHTML={{ __html: language[description] }}
          />
          {index !== layout.sections.length - 1 && (
            <Divider s={{ border: '1px solid #cbcbcb', margin: '1.5rem 0' }} />
          )}
        </div>
      ))}
      <div
        style={{
          marginTop: '2.5rem',
        }}
      >
        <NarvarFooter />
      </div>
    </div>
  );
};

FaqPage.defaultProps = {
  retailerFaqLayouts: {},
};

FaqPage.propTypes = {
  feature: PropTypes.string.isRequired,
  language: PropTypes.object.isRequired,
  retailerFaqLayouts: PropTypes.object,
};

export default connect(mapStateToProps)(FaqPage);
